const state = {

    Fourm: [],

}

const mutations = {
    SetFourm(state, payload) {

        state.Fourm = payload

    },
    SetIndividualFourm(state, payload) {

        state.Fourm.push(payload)

    },
    UpdateIndividualFourm(state, payload) {

        let index = state['Fourm'].findIndex(x => x["_id"] == payload["_id"])
        state['Fourm'].splice(index, 1, payload)

    },
    DeleteIndividualFourm(state, payload) {

        let index = state['Fourm'].findIndex(x => x["_id"] == payload["_id"])
        state['Fourm'].splice(index, 1)
    },
    DeleteMultipleFourm(state, payload) {

        payload.forEach(element => {
            let index = state['Fourm'].findIndex(x => x["_id"] == element)
            state['Fourm'].splice(index, 1)
        });
    }
}

const actions = {

}

const getters = {

    GetFourm(state) {

        return state.Fourm
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}